// The backend emits root-relative capability URLs for its own artifacts
// (report downloads: /agentforge/api/v1/files/…). The app and the AgentForge
// service are different origins outside the Caddy same-origin setup, so a
// relative href would resolve against the app origin and 404. Resolve them
// against VITE_AGENTFORGE_URL exactly like agentforge-http does; empty env
// (same-origin proxy) leaves the href relative, which is correct there.
export const resolveAgentforgeHref = (href?: string): string => {
  if (!href) return '#';
  if (href.startsWith('/agentforge/')) {
    return `${import.meta.env.VITE_AGENTFORGE_URL ?? ''}${href}`;
  }
  return href;
};
